import { Component, EventEmitter, TemplateRef, Output, ViewChild, Input } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppService } from '../../app.service';
import { messageService } from '../../message.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from '../success-snackbar/success-snackbar.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { qmsService } from '../../qms/qms.service';
import { AuService } from '../../qms/au/au.service';

@Component({
  selector: 'app-switchuser',
  templateUrl: './switchuser.component.html',
  styleUrls: ['./switchuser.component.scss']
})

export class SwitchuserComponent {
  @Output() valueEmitter = new EventEmitter<string>();
  @Input() user: any
  @Input() forms: any = {};

  isProcessing = false;

  constructor(private appService: AppService, public message: messageService, public dialog: MatDialog, private snackBar: MatSnackBar, public qmsservice: qmsService, public auService: AuService) { }
  @ViewChild('switchUserPopup1', { static: true }) switchUserPopup1: TemplateRef<any>;
  visibleswitchUserPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmationPopup', { static: true }) confirmationPopup: TemplateRef<any>;
  visibleConfirmationPopup: MatDialogRef<TemplateRef<any>>;
  switchUserTxt: any;
  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  };
  switchUserPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    position: { top: '10px' },
    maxWidth: '95vw',
    disableClose: true
  };

  confirmationPopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    position: { top: '10px' },
    maxWidth: '95vw',
    disableClose: true
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  openSwitchUserPopup() {
    this.reasonForSwitch = null;
    this.visibleswitchUserPopup = this.dialog.open(this.switchUserPopup1, this.switchUserPopupConfig);
  }

  cancelSwitchUserPopup() {
    this.visibleswitchUserPopup?.close();
  }

  labelName: any;
  switchUserRole: any;
  switchPageName: any;
  openswitchuser(role: any, pagename: any) {
    this.qmsservice.isSwitchUSerPopupOpened = true;
    console.log(role);
    if (role == "reviewer") {
      this.labelName = "Reviewer";
    } else if (role == "approver") {
      this.labelName = "Approver";
    } else if (role == "assignedTo") {
      this.labelName = "Assigned To";
    } else {
      this.labelName = role;
    }
    this.switchUserRole = role;
    this.switchPageName = pagename;
    this.openSwitchUserPopup();
  }

  reasonForSwitch: any;
  switchUserLogId: any;
  switchUserFunction() {
    if (this.message.switchedUser == null) {
      this.showSnackBar('Please select the ' + this.labelName + ' to switch', 'E');
      this.mandatoryValidation(this.message.switchedUser.length, 'user-validation');
    } else {
      const disallowedPages = ['CR', 'CAPA', 'DV', 'AU', 'IN', 'QI', 'CC', 'OOS', 'Extension', 'EC', 'Instructor Training', 'SU', 'Findings', 'FLS', 'Pre Action', 'FORMS', 'Action'];

      if (!disallowedPages.includes(this.switchPageName)) {
        if (!this.reasonForSwitch) {
          this.showSnackBar('Please enter the Reason', 'E');
          this.mandatoryValidation(this.reasonForSwitch, 'switch-reason-validation');
        } else {
          this.openConfirmationPopup();
        }
      } else {
        const isSameUser = (
          (this.switchPageName === 'CR' && this.switchUserRole == 'Owner' && this.message.switchedUser === this.qmsservice.crPageAllDropdownValues.ownerValue) ||
          (this.switchPageName === 'CR' && this.switchUserRole == 'QA' && this.message.switchedUser === this.qmsservice.crPageAllDropdownValues.qaUserValue) ||
          (this.switchPageName === 'CR' && this.switchUserRole == 'Department Head' && this.message.switchedUser === this.qmsservice.crPageAllDropdownValues.departmentHeadUserValue) ||
          (this.switchPageName === 'CAPA' && this.switchUserRole == 'Owner' && this.message.switchedUser === this.qmsservice.capaPageAllDropdownValues.ownerValue) ||
          (this.switchPageName === 'CAPA' && this.switchUserRole == 'QA' && this.message.switchedUser === this.qmsservice.capaPageAllDropdownValues.qaUserValue) ||
          (this.switchPageName === 'CAPA' && this.switchUserRole == 'Department Head' && this.message.switchedUser === this.qmsservice.capaPageAllDropdownValues.departmentHeadUserValue) ||
          (this.switchPageName === 'DV' && this.switchUserRole == 'Owner' && this.message.switchedUser === this.qmsservice.dvPageAllDropdownValues.ownerValue) ||
          (this.switchPageName === 'DV' && this.switchUserRole == 'QA' && this.message.switchedUser === this.qmsservice.dvPageAllDropdownValues.qaUserValue) ||
          (this.switchPageName === 'DV' && this.switchUserRole == 'Department Head' && this.message.switchedUser === this.qmsservice.dvPageAllDropdownValues.departmentHeadUserValue) ||
          (this.switchPageName === 'AU' && this.switchUserRole == 'ScheduleApprover' && this.message.switchedUser === this.auService.selectedScheduleApprover) ||
          (this.switchPageName === 'AU' && this.switchUserRole == 'PlanApprover' && this.message.switchedUser === this.auService.selectedPlanApprover) ||
          (this.switchPageName === 'AU' && this.switchUserRole == 'LeadAuditor' && this.message.switchedUser === this.auService.selectedLeadAuditor) ||
          (this.switchPageName === 'IN' && this.switchUserRole == 'Evaluator' && this.message.switchedUser === this.qmsservice.incidentDropDowns.selectedEvaluator) ||
          (this.switchPageName === 'IN' && this.switchUserRole == 'Investigator' && this.message.switchedUser === this.qmsservice.incidentDropDowns.selectedInvestigator) ||
          (this.switchPageName === 'QI' && this.switchUserRole == 'Evaluator' && this.message.switchedUser === this.qmsservice.qiDropDowns.selectedQiEvaluator) ||
          (this.switchPageName === 'QI' && this.switchUserRole == 'Investigator' && this.message.switchedUser === this.qmsservice.qiDropDowns.selectedQiInvestigator) ||
          (this.switchPageName === 'QI' && this.switchUserRole == 'QA' && this.message.switchedUser === this.qmsservice.qiDropDowns.selectedQiQa) ||
          (this.switchPageName === 'CC' && this.switchUserRole == 'Evaluator' && this.message.switchedUser === this.qmsservice.ccDropDowns.selectedEvaluator) ||
          (this.switchPageName === 'CC' && this.switchUserRole == 'Investigator' && this.message.switchedUser === this.qmsservice.ccDropDowns.selectedInvestigator) ||
          (this.switchPageName === 'CC' && this.switchUserRole == 'QA' && this.message.switchedUser === this.qmsservice.qiDropDowns.selectedQA) ||
          (this.switchPageName === 'Extension' && ((this.switchUserRole == 'Extension Reviewer' && this.message.switchedUser === this.qmsservice.selectedExtensionReview) || (this.switchUserRole == 'Extension Approver' && this.message.switchedUser === this.qmsservice.selectedExtensionApprove))) ||

          (this.switchPageName === 'OOS' && this.switchUserRole == 'Analyser' && this.message.switchedUser === this.qmsservice.activity.analysedBy) ||
          (this.switchPageName === 'OOS' && this.switchUserRole == 'Owner' && this.message.switchedUser === this.qmsservice.activity.owner) ||
          (this.switchPageName === 'OOS' && this.switchUserRole == 'QA' && this.message.switchedUser === this.qmsservice.activity.qa) ||
          (this.switchPageName === 'OOS' && this.switchUserRole == 'QA Acceptance' && this.message.switchedUser === this.qmsservice.activity.qaAcceptance) ||
          (this.switchPageName === 'OOS' && this.switchUserRole == 'Department Head' && this.message.switchedUser === this.qmsservice.activity.departmentHead) ||

          (this.switchPageName === 'EC' && ((this.switchUserRole == 'EC Owner' && this.message.switchedUser === this.qmsservice.ecDropdowns.selectedOwner) || (this.switchUserRole == 'EC Approver' && this.message.switchedUser === this.qmsservice.ecDropdowns.selectedApprover) ||
            (this.switchUserRole == 'EC QA Approver' && this.message.switchedUser === this.qmsservice.ecDropdowns.selectedQAApprover))) ||
          (this.switchPageName === 'Instructor Training' && this.message.switchedUser === this.message.scheduledTrainingsApprover) ||
          (this.switchPageName === 'SU' && (this.message.currentSwitchuser == this.message.switchedUser)) ||
          (this.switchPageName === 'Findings' && (this.message.switchUserCurrentValue == this.message.switchedUser)) ||
          (this.switchPageName === 'FLS' && (this.message.switchUserCurrentValue == this.message.switchedUser)) ||
          ((this.switchPageName === 'Pre Action') && (this.message.switchUserCurrentValue == this.message.switchedUser)) ||
          ((this.switchPageName === 'Action') && (this.message.switchUserCurrentValue == this.message.switchedUser)) ||
          (this.switchPageName === 'FORMS' && (this.message.switchUserCurrentValue == this.message.switchedUser))
        );

        if (isSameUser) {
          this.showSnackBar("Sorry! Can't switch to the same user", 'E');
        } else if (!this.reasonForSwitch && this.switchPageName !== 'FORMS') {
          this.showSnackBar('Please enter the Reason', 'E');
          this.mandatoryValidation(this.reasonForSwitch, 'switch-reason-validation');
        } else if ((this.switchPageName === 'Action' || this.switchPageName === 'Pre Action') && this.message.switchComparisonUser && this.message.switchedUser == this.message.switchComparisonUser) {
          this.showSnackBar('Defer Reviewer/Approver and Assign To User cannot be the same', 'E');
        } else {
          this.openConfirmationPopup();
        }
      }
    }
  };

  executeUserSwitch() {
    if (this.switchPageName === 'FORMS') {
      this.saveMethod();
      return;
    }
    if (this.switchPageName == "CR") {
      if (this.switchUserRole == "Owner") {
        this.qmsservice.crPageAllDropdownValues.ownerValue = this.message.switchedUser;
      } else if (this.switchUserRole == "QA") {
        this.qmsservice.crPageAllDropdownValues.qaUserValue = this.message.switchedUser;
      } else if (this.switchUserRole == "Department Head") {
        this.qmsservice.crPageAllDropdownValues.departmentHeadUserValue = this.message.switchedUser;
      }
    } else if (this.switchPageName == "CAPA") {
      if (this.switchUserRole == "Owner") {
        this.qmsservice.capaPageAllDropdownValues.ownerValue = this.message.switchedUser;
      } else if (this.switchUserRole == "QA") {
        this.qmsservice.capaPageAllDropdownValues.qaUserValue = this.message.switchedUser;
      } else if (this.switchUserRole == "Department Head") {
        this.qmsservice.capaPageAllDropdownValues.departmentHeadUserValue = this.message.switchedUser;
      }
    }
    this.valueEmitter.emit();
  }

  saveMethod() {
    this.isProcessing = true;
    let data: any = {};
    let selectedUserId = this.message.switchedUser;

    if (Array.isArray(this.message.switchedUser) && this.message.switchedUser.length > 0) {
      selectedUserId = this.message.switchedUser[0].valueExp;
    }
    else if (typeof this.message.switchedUser === 'object' && this.message.switchedUser !== null && this.message.switchedUser.valueExp) {
      selectedUserId = this.message.switchedUser.valueExp;
    }
    if (this.switchPageName === 'FORMS') {
      data = {
        module: 'FL',
        refNo: this.forms.recordId,
        version: null,
        groupId: this.forms.formId,
        subModuleName: this.forms.sectionName,
        subModuleRefNo: this.forms.sectionId,
        userRole: this.switchUserRole,
        fromUser: this.message.switchUserCurrentValue,
        toUser: selectedUserId,
        reasonForSwitch: this.reasonForSwitch,
        status: this.forms.status,
        deleteReason: null
      };
    } else {
      data = {
        module: this.qmsservice.moduleName ?? 'FL',
        refNo: this.message.activityId,
        version: this.message.version,
        groupId: this.qmsservice.moduleName == 'AU' ? this.qmsservice.selectedGroupDetailData.groupId : this.qmsservice.selectedGroup,
        subModuleName: this.message.submodule,
        subModuleRefNo: this.message.subModuleId,
        userRole: this.switchUserRole,
        fromUser: this.message.switchUserCurrentValue,
        toUser: selectedUserId,
        reasonForSwitch: this.reasonForSwitch,
        status: this.qmsservice.activity.status,
        deleteReason: null
      }
    }
    this.appService.createOneQmsSwitchUserLog(data).subscribe({
      next: (Response: any) => {
        if (Response.resultType != "S") {
          this.showSnackBar(Response.result, Response.resultType);
          this.isProcessing = false;
        } else {
          this.showSnackBar(Response.result, Response.resultType);
          this.visibleswitchUserPopup.close();
          this.visibleConfirmationPopup.close();
          this.isProcessing = false;
          if (this.switchPageName === 'FORMS') {
            this.valueEmitter.emit(selectedUserId);
          }
        }
      },
      error: (error) => { this.isProcessing = false; throw error; }
    });

  }
  onUserSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.handleDropDownValidation('user-validation', item.valueExp);
      } else {
        this.handleDropDownValidation('user-validation', item.valueExp);
      }
    }
  }

  onUserDeSelect() {
    this.handleDropDownValidation('user-validation', this.message.switchedUser);
  }

  handleDropDownValidation(fieldId: string, selectedItems: any) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = selectedItems == null && field ? 'red' : '';
  }


  mandatoryValidation(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '' : 'red';
  }

  openConfirmationPopup() {
    this.visibleConfirmationPopup = this.dialog.open(this.confirmationPopup, this.confirmationPopupConfig);
  }

  closeConfirmationPopup() {
    this.visibleConfirmationPopup.close();
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: !this.message.breadcrumbData.thirdLevel
          ? this.message.breadcrumbData.secondLevel
          : this.message.breadcrumbData.thirdLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });
    sb.onAction().subscribe({
      next: () => {
        sb.dismiss();
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      },
      complete: () => { }
    })
  }
}
